import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../../base';

export class Balance extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/balance`);
  }

  query() {
    return this.api.query().pipe(
      tap((json) => this.processRecord(json.balance))
    )
  }

  private processRecord(record: any) {
    record.amount = new BigNumber(record.amount).fromDecimal();
  }
}
